<template>
  <div id="app">
    <el-container>
      <el-header>
        <navbar></navbar>
      </el-header>
      <el-main
        ><mainsearch></mainsearch>
      </el-main>
      <el-footer>
        <icp-footer></icp-footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import navbar from '../../components/navbar.vue'
import mainsearch from '../../components/mainsearch.vue'
import icpFooter from '../../components/icpFooter.vue'
export default {
  components: {
    navbar,
    mainsearch,
    icpFooter
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style>

</style>
